/**
 * Determines user membership status based on email presence
 * 
 * @param email - User email value which can be a string, false, or undefined
 * @returns 'SITE_MEMBER' if email exists as a string, otherwise 'NOT_MEMBER'
 */
export function getUserStatus(email?: string | false | undefined): 'SITE_MEMBER' | 'NOT_MEMBER' {
  return typeof email === 'string' ? 'SITE_MEMBER' : 'NOT_MEMBER';
}

/**
 * Determines user membership status from userEmailData object
 * 
 * @param userEmailData - Object containing user email information
 * @returns 'SITE_MEMBER' if email exists as a string, otherwise 'NOT_MEMBER'
 */
export function getUserStatusFromData(userEmailData?: { 
  email?: string | false | undefined;
  [key: string]: any; 
}): 'SITE_MEMBER' | 'NOT_MEMBER' {
  return getUserStatus(userEmailData?.email);
}

/**
 * Checks if user is a site member based on email presence
 * 
 * @param email - User email value which can be a string, false, or undefined
 * @returns true if user is a site member, false otherwise
 */
export function isSiteMember(email?: string | false | undefined): boolean {
  return typeof email === 'string';
}

/**
 * Checks if user is a site member from userEmailData object
 * 
 * @param userEmailData - Object containing user email information
 * @returns true if user is a site member, false otherwise
 */
export function isSiteMemberFromData(userEmailData?: { 
  email?: string | false | undefined;
  [key: string]: any; 
}): boolean {
  return isSiteMember(userEmailData?.email);
}

export default getUserStatusFromData;